import { api } from "@/axios";

const state = {
  user: null,
};

const getters = {
  getUser: () => localStorage.getItem("user"), // state.user,
  isLogged: () => (localStorage.getItem("user") !== null ? true : false),
};

const actions = {
  async login({ commit }, credentials) {
    try {
      //console.log("credentials", credentials);
      const resp = await api.post("/login", credentials);
      //console.log("resp", resp);
      if (resp.status == 200) {
        let user = resp.data.user;
        user.token = resp.data.access_token;
        localStorage.setItem("user", JSON.stringify(user));
        // localStorage.setItem("token", JSON.stringify(resp.data.access_token));
        //console.log("uuu", localStorage.getItem("user"));
        commit("setUser", user);
      }

      // if (credentials.email == "user@gmail.com") {
      //   const user = {
      //     email: "user@gmail.com",
      //     token: "token123",
      //     roles: ["admin", "user"],
      //   };
      //   localStorage.setItem("user", JSON.stringify(user));
      //   console.log("uuu", localStorage.getItem("user"));
      //   commit("setUser", user);
      // }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async logout({ commit }) {
    try {
      const resp = await api.post("/logout");
      //console.log("resp", resp);
      if (resp.status == 200) {
        localStorage.removeItem("user");
      }
      commit("setUser", null);
      return true;
    } catch (error) {
      return false;
    }
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
